"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const ContentBox_1 = __importDefault(require("../components/ContentBox"));
/**
 * @deprecated - Prefer the components from the PageTemplate.tsx file in the app instead.
 */
function Content({ className, sx, children }) {
    return ((0, jsx_runtime_1.jsx)(Stack_1.default, Object.assign({ className: className, direction: "row", sx: Object.assign({ padding: 2 }, sx), alignItems: "flex-start", justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(ContentBox_1.default, { children: children }) })));
}
exports.default = Content;
